<template>
  <section>
    <AgendamentoModal
      :data-atendimento="dataFormatadaAgenda"
      :tecnico="agendamentosStore.state?.tecnico?.value"
      :atendimento="agendamentosStore.state?.atendimento"
      :item="agendamento_cadastro"
      :expediente="agendamentosStore.state?.expedienteAgenda?.horario"
      :save-agendamento="() => saveAgendamento()"
    />

    <AgendaTecnicoImpressaoModal
      :tecnico="agendamentosStore.state?.tecnico?.value"
      :data-atendimento="dataFormatadaAgenda"
      :expediente="agendamentosStore.state?.expedienteAgenda?.horario"
      :unidade="agendamentosStore.state?.expedienteAgenda?.unidade"
      :agenda="agendamentosStore.state?.agenda"
      visible="agenda-tecnico-impressao-modal"
      :get-text-status-style="(it) => getTextStatusStyle(it)"
    />

    <AtendimentoImpressaoModal
      :agendamento="agendamentosStore.state?.agendamento"
      visible="atendimento-agenda-impressao-modal"
    />

    <stepper
      :items="items"
      class="mt-3"
      :action-next="(idx) => actionNext(idx)"
      :action-prev="(idx) => actionPrev(idx)"
      :is-valid-to-next="agendamentosStore.state?.is_valid_to_next"
    >
      <template v-slot:0>
        <section class="row">
          <div class="col-12">
            <h4 class="font-weight-bold">
              Realizar agendamentos para Usuários
            </h4>
          </div>

          <form-radio
            grid="12"
            name="situacao"
            v-model="situacao_usuario"
            :itens="options_radio"
          />
        </section>

        <section class="row mt-2" v-if="situacao_usuario">
          <div class="col-12 border-top">
            <h4 class="font-weight-bold mt-3">
              Usuário com cadastro
            </h4>
          </div>

          <div class="col-12 d-flex align-items-center mt-2 mb-3">
            <div class="float-left mr-2">
              <toggle-button
                :sync="true"
                color="#5685D8"
                id="buscaSituacaoRua"
                name="buscaSituacaoRua"
                v-model="situacao_rua"
              />
            </div>
            Buscar somente por pessoas em situação de rua?
          </div>

          <form-select
            :customOption="true"
            valueOption="usuario_id"
            labelOption="nome_completo"
            label="Usuário"
            ajuda="Para <b>buscar usuários em situação de rua</b>, ative a opção acima antes de realizar a busca no seletor."
            grid="12"
            name="searchUser"
            id="searchUser"
            placeholder="Busque pelo nome, nome social ou CPF"
            @search="getSearchUser"
            v-model="usuario"
            :filter="filter"
            @change="setUser"
            :loading="agendamentosStore.state.loadingUser"
            :itens="agendamentosStore.state.usuarios"
          >
            <template v-slot:option="option">
              <b-icon
                v-if="option.situacao_rua"
                icon="exclamation-triangle-fill"
                variant="warning"
                animation="fade"
              >
              </b-icon>
              {{ option.nome_social || option.nome_completo }} - {{ option.idade }}
            </template>
          </form-select>

          <div class="col-12" v-if="agendamentosStore.state.usuario">
            <table class="b-table table table-bordered bg-white b-table-stacked-md table-sm">
              <tbody>
              <tr>
                <td colspan="3">
                  <strong> Dados do responsável familiar </strong>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>
                    {{
                      (agendamentosStore.state.usuario?.responsavel_familiar_nome_social)
                        ? agendamentosStore.state.usuario?.responsavel_familiar_nome_social
                        : agendamentosStore.state.usuario?.responsavel_familiar_nome
                    }}
                  </strong>
                  <b-link
                    :to="'/dashboard/familias/edit/' + agendamentosStore.state.usuario?.id"
                    target="_blank"
                    :title="$t('Ver Prontuário Familiar')"
                    v-b-tooltip.hover
                  >
                    <i class="fas fa-external-link-alt"></i>
                  </b-link>
                  <span v-if="agendamentosStore.state.usuario?.responsavel_familiar_nome_social">
                    <br/>
                    ( N.R.: )
                    <template v-if="!show_name_responsavel_familiar[agendamentosStore.state.usuario.id]">
                      <a href="#" @click.prevent="toggleResponsavelFamiliar(agendamentosStore.state.usuario.id, true)">
                        <i class="fas fa-eye"></i>
                      </a>
                    </template>
                    <template v-else>
                      <span>
                        <strong>{{ agendamentosStore.state.usuario?.responsavel_familiar_nome }}</strong>
                        <a href="#"
                           @click.prevent="toggleResponsavelFamiliar(agendamentosStore.state.usuario.id, false)">
                          <i class="fas fa-eye-slash"></i>
                        </a>
                      </span>
                    </template>
                  </span>
                  <br/>
                  <small class="text-muted">
                    Idade: {{ agendamentosStore.state.usuario.responsavel_familiar_idade }}
                  </small>
                </td>
                <td>
                <span>
                  ID Familiar:
                  <strong> {{ agendamentosStore.state.usuario?.id }} </strong>
                </span>
                </td>
                <td>
                <span>
                  Família Cadastrada:
                  <strong> {{ agendamentosStore.state.usuario?.data_cadastramento }} </strong>
                </span>
                </td>
              </tr>
              <tr>
                <td>
                <span>
                  Endereço:
                  <strong>{{ agendamentosStore.state.usuario?.endereco?.logradouro }}</strong>
                </span>
                </td>
                <td>
                  Contato:
                  <span>
                  <strong>{{ agendamentosStore.state.usuario?.contato }}</strong>
                </span>
                </td>
                <td>
                  <b-icon
                    icon="exclamation-triangle-fill"
                    v-if="agendamentosStore.state.usuario?.situacao_rua"
                    variant="warning"
                    animation="fade"
                  >
                  </b-icon>
                  Pessoa em situação de rua:
                  <strong>{{ agendamentosStore.state.usuario?.situacao_rua ? 'SIM' : 'NÃO' }}</strong>
                </td>
              </tr>
              </tbody>
            </table>
          </div>

          <div class="col-12" v-if="agendamentosStore.state.usuario">
            <table class="table b-table table-bordered b-table-stacked-md table-sm">
              <tbody>
              <tr>
                <td colspan="12">
                  <strong> Membros da família disponíveis para agendamento </strong>
                </td>
              </tr>
              <tr>
                <td>
                  <strong> Selecione </strong>
                </td>
                <td>
                  <strong> Nome </strong>
                </td>
              </tr>

              <tr v-for="user in agendamentosStore.state.usuario?.familiares" :key="user.id">
                <td class="text-center" style="width: 100px; min-width: 100px">
                  <toggle-button
                    :sync="true"
                    color="#5685D8"
                    id="incluirAgendamento"
                    name="incluirAgendamento"
                    v-model="users_selected[user.id]"
                    @change="handleToggle(user)"
                  />
                </td>
                <td>
                  <strong>
                    {{
                      (user?.nome_social)
                        ? user?.nome_social
                        : user?.nome_completo
                    }}
                  </strong>
                  <b-link
                    :to="`/dashboard/usuario/edit/${user.id}`"
                    target="_blank"
                    :title="$t('Ver Prontuário do Usuário')"
                    v-b-tooltip.hover
                  >
                    <i class="fas fa-external-link-alt"></i>
                  </b-link>
                  <span v-if="user?.nome_social">
                    <br/>
                    ( N.R.: )
                    <template v-if="!show_name[user.id]">
                      <a href="#" @click.prevent="toggleName(user.id, true)">
                        <i class="fas fa-eye"></i>
                      </a>
                    </template>
                    <template v-else>
                      <span>
                        <strong>{{ user?.nome_completo }}</strong>
                        <a href="#" @click.prevent="toggleName(user.id, false)">
                          <i class="fas fa-eye-slash"></i>
                        </a>
                      </span>
                    </template>
                  </span>
                  <br/>
                  <small class="text-muted">
                    Idade: {{ user.idade }}
                  </small>
                </td>
              </tr>
              </tbody>
            </table>
          </div>

        </section>

        <section class="row mt-2" v-else>
          <div class="col-12 border-top">
            <h4 class="font-weight-bold mt-3 mb-2">
              Usuário sem cadastro
            </h4>
          </div>

          <form-input
            grid="9"
            label="Nome completo"
            ajuda="Não será permitido acentos ou caracteres especiais neste campo."
            v-model="item.nome_completo"
            :required="true"
          />

          <form-input
            label="Data de nascimento"
            grid="3"
            type="date"
            :required="true"
            v-model="item.data_nascimento"
          />

          <form-input
            v-model="item.cpf"
            label="CPF"
            grid="6"
            v-mask="'###.###.###-##'"
            placeholder="000.000.000-00"
            :required="!item.situacao_rua"
            :readonly="item.nao_sabe_cpf ? true : false"
          />

          <div class="col-md-6 col-sm-12 d-flex align-items-center">
            <div class="float-left mr-2">
              <toggle-button
                :sync="true"
                color="#5685D8"
                id="nomeSocial"
                name="nomeSocial"
                v-model="item.use_nome_social"
              />
            </div>
            Deseja adicionar Nome Social?
          </div>

          <form-toggle
            grid="12"
            v-model="item.nao_sabe_cpf"
            label="Não sabe"
          />

          <form-input
            v-if="item.use_nome_social"
            grid="12"
            label="Nome social"
            :required="item.use_nome_social"
            v-model="item.nome_social"
          />

          <div class="col-3 d-flex align-items-center">
            <div class="float-left mr-2">
              <toggle-button
                :sync="true"
                color="#5685D8"
                id="situacaoRua"
                name="situacaoRua"
                v-model="item.situacao_rua"
              />
            </div>
            Pessoa em situação de rua?
          </div>

          <div class="col-12 border-top mt-3" v-if="!item.situacao_rua">
            <h4 class="font-weight-bold mt-3 mb-2">
              Endereço
            </h4>

            <form-endereco
              :item="item.endereco"
            />
          </div>

          <div class="row col-12 mt-3 pr-0" v-else>
            <h4 class="col-12 font-weight-bold mb-2">
              Referência para localização do Usuário/Família em Situação de Rua
            </h4>
            <form-input
              grid="12"
              class="pr-0"
              :required="item.situacao_rua"
              v-model="item.endereco.referencia_endereco"
              label="Descrição da referência"
            />
          </div>

          <div class="col-12 d-flex align-items-center mt-3">
            <div class="float-left mr-2">
              <toggle-button
                :sync="true"
                color="#5685D8"
                id="abrigo"
                name="abrigo"
                v-model="item.endereco.abrigo"
              />
            </div>
            Endereço de Acolhimento Institucional?
          </div>

          <div class="col-12 border-top mt-3">
            <h4 class="font-weight-bold mt-3 mb-2">
              Contatos
            </h4>
          </div>

          <form-input
            grid="3"
            label="E-mail"
            v-model="email.contato"
            type="email"
          />

          <div class="col-9 d-flex align-items-center mt-3">
            <div class="float-left mr-2">
              <toggle-button
                :sync="true"
                color="#5685D8"
                id="permiteNotificacaoEmail"
                name="permiteNotificacaoEmail"
                v-model="email.permite_notificacao"
              />
            </div>
            Permite notificação?
          </div>

          <div class="row col-12" v-for="(contato, idx) in item.contatos" :key="idx">
            <form-input
              label="Telefone"
              grid="3"
              v-mask="'(##) # ####-####'"
              placeholder="(00) 0 0000-0000"
              v-model="contato.contato"
            />

            <form-select
              grid="3"
              label="Tipo de contato"
              v-model="contato.tipo_contato_id"
              :loading="agendamentosStore?.state?.loadingSelectOptions"
              :itens="agendamentosStore?.state?.tipos_contato"
            />

            <div class="col-6 d-flex align-items-center mt-3">
              <div class="float-left mr-2">
                <toggle-button
                  :sync="true"
                  color="#5685D8"
                  id="permiteNotificacao"
                  name="permiteNotificacao"
                  v-model="contato.permite_notificacao"
                />
              </div>
              Permite o envio de SMS?

              <div class="ml-3 d-flex align-items-center">
                <b-button
                  :title="$t('Remover contato')"
                  class="px-2 mb-0"
                  size="xs"
                  type="button"
                  v-b-tooltip.hover
                  variant="danger"
                  v-if="item.contatos.length > 1"
                  @click="removeContact(idx)"
                >
                  <i class="mdi mdi-minus"/>
                </b-button>

                <b-button
                  :title="$t('Adicionar novo contato')"
                  class="px-2 mb-0"
                  size="xs"
                  type="button"
                  v-b-tooltip.hover
                  variant="primary"
                  v-if="idx === item.contatos.length - 1"
                  @click="addContact()"
                >
                  <i class="mdi mdi-plus"/>
                </b-button>
              </div>
            </div>
          </div>
        </section>
      </template>
      <template v-slot:1>
        <section class="row">
          <div class="col-12">
            <h4 class="font-weight-bold">
              Atendimento
            </h4>
          </div>

          <form-input
            :required="true"
            grid="12"
            label="Descrição do atendimento"
            v-model="atendimento.descricao_sumaria"
          />

          <div class="col-4 d-flex align-items-center">
            <div class="float-left mr-2">
              <toggle-button
                :sync="true"
                color="#5685D8"
                id="interprete"
                name="interprete"
                v-model="atendimento.necessita_interprete_libras"
              />
            </div>
            Necessita de intérprete de Libras?
          </div>

          <form-calendar
            :required="true"
            grid="3"
            label="Data da solicitação"
            id="dataSolicitacao"
            name="dataSolicitacao"
            :max-date="date_now"
            v-model="atendimento.data_cadastro"
          />

          <form-select
            :required="true"
            grid="5"
            label="Formas de acesso"
            id="formasAcesso"
            name="formasAcesso"
            :loading="agendamentosStore?.state?.loadingSelectOptions"
            :itens="agendamentosStore?.state?.formas_acesso"
            v-model="atendimento.forma_acesso_id"
          />

          <form-select
            :required="true"
            grid="6"
            label="Onde será atendido"
            id="local"
            name="local"
            :loading="agendamentosStore?.state?.loadingSelectOptions"
            :itens="agendamentosStore?.state?.locais_atendimento"
            v-model="atendimento.local"
            @selected="setLocal"
          />

          <form-select
            grid="6"
            v-if="agendamentosStore.state?.local_atendimento?.permite_outra_unidade"
            label="Unidades internas"
            id="unidadesInternas"
            name="unidadesInternas"
            :loading="agendamentosStore?.state?.loadingSelectOptions"
            :itens="agendamentosStore?.state?.unidades_internas"
            v-model="atendimento.outra_unidade"
          />

          <form-select
            grid="6"
            label="Serviço SOCIOASSISTENCIAL"
            id="servico"
            name="servico"
            :loading="agendamentosStore?.state?.loadingSelectOptions"
            :itens="agendamentosStore?.state?.servicos"
            v-model="atendimento.tipo_servico_id"
          />

          <form-select
            :grid="agendamentosStore.state?.local_atendimento?.permite_outra_unidade ? '6' : '12'"
            :multiple="true"
            :required="true"
            label="Tipo de atendimento solicitado"
            id="tipoAtendimentoSolicitado"
            name="tipoAtendimentoSolicitado"
            :loading="agendamentosStore?.state?.loadingSelectOptions"
            :itens="agendamentosStore?.state?.tipos"
            v-model="atendimento.tipos"
          />
        </section>
      </template>
      <template v-slot:2>
        <section class="row">
          <div class="col-12">
            <h4 class="font-weight-bold">
              Agendamento
            </h4>
          </div>

          <form-select
            grid="6"
            label="Unidade"
            id="unidade"
            name="unidade"
            :loading="agendamentosStore?.state?.loadingSelectOptions"
            :itens="agendamentosStore?.state?.unidades_internas"
            v-model="agendamento.unidade_id"
          />

          <form-select
            grid="6"
            label="Níveis"
            id="niveis"
            name="niveis"
            :loading="agendamentosStore?.state?.loadingSelectOptions"
            :itens="agendamentosStore?.state?.niveis"
            v-model="agendamento.nivel_id"
          />
        </section>

        <section class="mt-3 d-flex" style="column-gap: 20px">
          <v-date-picker
            is-required
            locale="pt-BR"
            :model-config="{ type: 'string', mask: 'YYYY-MM-DD' }"
            v-model="agenda.data_agendamento"
            @input="getDataAgendamento"
          />
          <div class="d-flex flex-column w-100" style="gap: 15px">
            <div>
              <form-select
                :noGrid="true"
                class="pl-0"
                label="Técnicos"
                id="tecnicos"
                name="tecnicos"
                placeholder="Selecione uma unidade e um nível para visualizar os técnicos"
                :disabled="agendamentosStore?.state?.loadingTecnicos"
                :loading="agendamentosStore?.state?.loadingTecnicos"
                :itens="agendamentosStore?.state?.tecnicos"
                v-model="agenda.tecnico_id"
                @selected="setTecnico"
              />
              <small class="font-size-12">
                Por favor, selecione um dia e um técnico para visualizar a agenda.
              </small>
            </div>
            <div v-if="verificarUsuarioLogadoAgenda()" class="d-flex flex-column w-100" style="gap: 15px">
              <load mode="table" text="Aguarde um momento." v-if="agendamentosStore?.state?.loadingAgenda"/>

              <section v-else>
                <div
                  class="alert alert-info alert-dismissible fade show shadow text-dark"
                  role="alert"
                >
                  <h5 class="mb-0">
                    <b> Obs.</b> Os horários exibidos na agenda correspondem apenas aos compromissos já <b>
                    cadastrados </b>. Para <b> agendar </b> um <b> novo atendimento </b>,
                    clique no botão azul <b> "+" </b> localizado na tabela!
                  </h5>
                  <button
                    type="button"
                    class="close text-danger"
                    data-dismiss="alert"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <table
                  class="b-table table bg-white b-table-stacked-md table-sm mb-0"
                  style="border: 1px solid #0000152C;"
                >
                  <tbody>
                    <tr style="background: #f8fafc;">
                      <td colspan="4" style="border: 1px solid #0000152C;">
                        <section class="d-flex align-items-center justify-content-between pt-1 pb-1">
                          <strong>
                            Agenda - {{ dataFormatadaAgenda }}
                            {{ agendamentosStore.state?.expedienteAgenda?.horario ? `(${agendamentosStore.state?.expedienteAgenda?.horario})` : null }}
                          </strong>
                          <b-button
                            :title="$t('Agendar atendimento')"
                            size="xs"
                            class="mb-0"
                            type="button"
                            v-b-tooltip.hover
                            variant="primary"
                            @click="$bvModal.show('agendamentos-modal')"
                          >
                            <i class="fas fa-light fa-plus"></i>
                          </b-button>
                        </section>
                      </td>
                    </tr>
                    <template v-if="agendamentosStore.state.agenda?.periodo">
                      <tr>
                        <td style="border: 1px solid #0000152C; padding-top: 10px; padding-bottom: 10px;">
                          <strong class="d-flex align-items-center flex-wrap" style="column-gap: 5px">
                            <i
                              v-if="agendamentosStore.state.agenda?.periodo?.icone"
                              :class="`mdi mdi-18px ${agendamentosStore.state.agenda?.periodo?.icone}`"
                            />
                            {{ agendamentosStore.state.agenda?.periodo?.descricao }}
                            ({{ agendamentosStore.state.agenda?.periodo?.dia | formatDate() }}
                            à
                            {{ agendamentosStore.state.agenda?.periodo?.dia_fim | formatDate() }})
                          </strong>
                        </td>
                      </tr>
                    </template>
                    <template v-else-if="agendamentosStore.state.agenda?.agenda?.length > 0">
                      <tr class="font-size-15" v-for="(item, idx) in agendamentosStore.state.agenda?.agenda" :key="idx">
                        <td style="white-space: nowrap; width: 1%; border: 1px solid #0000152C;">
                          <strong> {{ item?.horario }} </strong>
                        </td>

                        <td
                          style="
                            border-top: 1px solid #0000152C;
                            border-bottom: 1px solid #0000152C;
                            border-left: 1px solid #0000152C;
                          "
                        >
                          <div class="d-flex flex-column">
                            <span>
                              <strong v-if="!show_name_agenda[item.id]">
                                {{ item?.atendimento?.usuarios[0]?.nome }}
                                <span v-if="item?.atendimento?.usuarios?.length > 1">
                                   e mais {{ item?.atendimento?.usuarios?.length - 1 }} pessoa(s)
                                </span>
                              </strong>
                              <template v-if="item?.atendimento?.usuarios?.length > 1">
                                <template v-if="!show_name_agenda[item.id]">
                                  <a href="#" @click.prevent="toggleNameAgenda(item.id, true)">
                                    Ver mais
                                  </a>
                                </template>
                                <template v-else>
                                  <span>
                                    <strong> {{ item?.atendimento?.usuarios.map(it => it?.nome).join(', ') }} </strong>
                                    <a href="#" @click.prevent="toggleNameAgenda(item.id, false)">
                                      Ver menos
                                    </a>
                                  </span>
                                </template>
                              </template>
                            </span>
                            <strong v-if="item?.atendimento">
                              {{ item?.atendimento?.descricao }}
                            </strong>

                            <strong
                              :style="getTextStatusStyle(item)"
                              v-if="!item.atendimento || (item?.atendimento && item?.status?.value === 'REAGENDADO')"
                            >
                              {{ item?.descricao }}
                            </strong>
                          </div>
                        </td>

                        <td
                          class="font-size-14"
                          style="
                          white-space: nowrap;
                          width: 1%;
                          border-top: 1px solid #0000152C;
                          border-bottom: 1px solid #0000152C;
                          padding: 6px;
                        "
                          :colspan="item?.atendimento ? 1 : 2"
                        >
                          <strong :style="{ color: item?.status?.cor }">
                            {{ item?.status?.value }}
                          </strong>
                        </td>

                        <td
                          v-if="item?.atendimento"
                          style="
                            white-space: nowrap;
                            width: 1%;
                            text-align: right;
                            border-top: 1px solid #0000152C;
                            border-bottom: 1px solid #0000152C;
                            border-right: 1px solid #0000152C;
                          "
                        >
                          <b-dropdown
                            size="lg"
                            no-caret
                            variant="link"
                            v-b-tooltip.hover
                            right
                            title="Opções"
                            toggle-class="text-decoration-none"
                          >
                            <template #button-content>
                              <i class="fas fa-ellipsis-v" style="color: black"></i>
                            </template>
                            <b-dropdown-item @click="() => impressaoAgendamento(item)">
                              <div class="d-flex align-items-center" style="column-gap: 5px">
                                <i class="fas fa-print"></i>
                                Imprimir Agendamento
                              </div>
                            </b-dropdown-item>
                            <b-dropdown-item>
                              <div class="d-flex align-items-center" style="column-gap: 5px">
                                <i class="fas fa-envelope"></i>
                                Enviar mensagem eletrônica
                              </div>
                            </b-dropdown-item>
                            <b-dropdown-item @click="() => cancelar(item)">
                              <div class="d-flex align-items-center" style="column-gap: 5px">
                                <i class="fas fa-times"></i>
                                Cancelar
                              </div>
                            </b-dropdown-item>
                          </b-dropdown>
                        </td>
                      </tr>
                    </template>
                    <template v-else>
                      <div class="text-center mt-3">
                        <img
                          :alt="$t('No results')"
                          src="/img/icons/robot.svg"
                          style="max-height: 200px"
                        />
                        <h3 class="bold">
                          {{ $t("No records found") }}
                        </h3>
                      </div>
                    </template>
                  </tbody>
                </table>
              </section>

              <div class="d-flex justify-content-end">
                <b-button
                  :title="$t('Visualizar e Imprimir')"
                  type="button"
                  class="m-0"
                  style="padding: 7px 15px"
                  v-b-tooltip.hover
                  variant="primary"
                  v-if="agendamentosStore.state.agenda?.agenda?.length > 0 || agendamentosStore.state.agenda?.periodo"
                  @click="$bvModal.show('agenda-tecnico-impressao-modal')"
                >
                  <i class="fas fa-light fa-print"></i>
                </b-button>
              </div>
            </div>

            <div v-else class="text-center">
              <img
                :alt="$t('No results')"
                src="/img/icons/robot.svg"
                style="max-height: 200px"
              />
              <h3 class="bold">
                {{ $t("Nenhuma agenda encontrada") }}
              </h3>
            </div>
          </div>
        </section>
      </template>
    </stepper>
  </section>
</template>

<script>
import lodash from "lodash";
import AgendamentoModal from "./components/AgendamentoModal.vue";
import AgendaTecnicoImpressaoModal from "./components/AgendaTecnicoImpressaoModal.vue";
import AtendimentoImpressaoModal from "./components/AtendimentoImpressaoModal.vue";

export default {
  components: {
    AtendimentoImpressaoModal,
    AgendaTecnicoImpressaoModal,
    AgendamentoModal
  },
  inject: ["agendamentosStore"],
  data() {
    return {
      usuario: null,
      dataFormatadaAgenda: null,
      situacao_rua: false,
      situacao_usuario: true,
      users_selected: {},
      show_name_responsavel_familiar: {},
      show_name: {},
      show_name_agenda: {},
      selected_users: [],
      date_now: moment().format("YYYY/MM/DD"),
      email: {
        contato: null,
        tipo_contato_id: null,
        permite_notificacao: false,
      },
      agendamento: {
        unidade_id: null,
        nivel_id: null,
      },
      agenda: {
        tecnico_id: null,
        data_agendamento: moment().format("YYYY-MM-DD"),
      },
      items: [
        { index: 1, label: "Usuário" },
        { index: 2, label: "Atendimento" },
        { index: 3, label: "Agendamento" },
      ],
      options_radio: [
        { id: true, value: "Com cadastro" },
        { id: false, value: "Sem cadastro" },
      ],
      atendimento: {
        pessoas: null,
        local: null,
        tipos: null,
        tipo_servico_id: null,
        outra_unidade: null,
        descricao_sumaria: null,
        familia_id: null,
        data_cadastro: moment().format("YYYY-MM-DD"),
        necessita_interprete_libras: false,
        forma_acesso_id: null
      },
      item: {
        nome_completo: null,
        nome_social: null,
        use_nome_social: false,
        data_nascimento: null,
        cpf: null,
        situacao_rua: false,
        nao_sabe_cpf: false,
        endereco: {
          numero_endereco: null,
          complemento_endereco: null,
          referencia_endereco: null,
          abrigo: false,
          localidade_id: null,
          logradouro_id: null,
          estado_id: null,
          cidade_id: null,
          cidade: null,
          estado: null,
          localidade: null,
          logradouros: null,
          cep: null,
        },
        contatos: [
          {
            contato: null,
            tipo_contato_id: null,
            permite_notificacao: false,
          }
        ]
      },
      agendamento_cadastro: {
        dia: null,
        hora_inicio: null,
        hora_fim: null,
        descricao: null,
        tecnico_id: null,
        atendimento: {
          id: null
        },
        atendimento_id: null,
        usuarios_ids: [],
        unidade_id: null
      },
      is_tecnico: this.$store.state?.user?.role_details?.name?.toLowerCase()?.includes("técnico"),
      tecnico_logado: this.$store.state?.user?.tecnico
    }
  },
  mounted() {
    this.agendamentosStore.dispatch("getSelectOptions");
  },
  computed: {
    dadosAgendamento() {
      return {
        data_agendamento: this.agenda.data_agendamento,
        unidade_id: this.agendamento.unidade_id
      }
    }
  },
  watch: {
    agendamento: {
      handler: function (newVal) {
        if (newVal.nivel_id && newVal.unidade_id) {
          this.agenda.tecnico_id = null;

          this.agendamentosStore.dispatch("getTecnicos", {
            funcao_unidade: newVal.nivel_id,
            unidade_id: newVal.unidade_id,
          });
        }
      },
      deep: true
    },

    agenda: {
      handler: function (newVal) {
        const { data_agendamento, tecnico_id } = newVal;

        if (!data_agendamento) return;

        const tecnicoId = tecnico_id || null;

        if (tecnicoId) this.getAgenda(tecnicoId, data_agendamento);
      },
      deep: true
    },

    dadosAgendamento: {
      handler: function (newVal) {
        if (newVal.data_agendamento && newVal.unidade_id) {
          this.getExpediente(newVal.unidade_id, newVal.data_agendamento)
        }
      }
    }
  },
  methods: {
    getExpediente(unidade_id, data_agendamento) {
      this.agendamentosStore.dispatch("getExpediente", {
        unidade_id: unidade_id,
        dia: data_agendamento,
        model_mutations: "SET_EXPEDIENTE_AGENDA"
      });
    },

    toggleResponsavelFamiliar(id, state) {
      this.$set(this.show_name_responsavel_familiar, id, state);
    },

    toggleName(id, state) {
      this.$set(this.show_name, id, state);
    },

    toggleNameAgenda(id, state) {
      this.$set(this.show_name_agenda, id, state);
    },

    removeContact(idx) {
      this.item.contatos.splice(idx, 1)
    },

    addContact() {
      this.item.contatos.push({ contato: null, tipo_contato_id: null, permite_notificacao: false })
    },

    handleToggle(user) {
      if (this.users_selected[user.id]) {
        this.selected_users.push(user);
      } else {
        this.selected_users = this.selected_users.filter(
          (selectedUser) => selectedUser.id !== user.id
        );
      }
    },

    limparEstado(obj, camposPreservados = []) {
      for (const key in obj) {
        if (camposPreservados.includes(key)) {
          continue;
        }

        if (typeof obj[key] === "object" && obj[key] !== null) {
          this.limparEstado(obj[key], camposPreservados);
        } else if (typeof obj[key] === "boolean") {
          obj[key] = false;
        } else {
          obj[key] = null;
        }
      }
    },

    async actionNext(idx) {
      switch (idx) {
        case 0:
          await this.saveUsuario();
          break;
        case 1:
          await this.saveAtendimento(true);
          break;
        case 2:
          await this.finalizar();
          break;
      }
    },

    async actionPrev(idx) {
      switch (idx) {
        case 0:
          await this.clearStep1();
          break;
        case 1:
          this.getAtendimento();
          break;
        case 2:
          this.setIsValidToNext(true);
          break;
        case 3:
          this.setIsValidToNext(true);
          break;
      }
    },

    setIsValidToNext(vl) {
      this.agendamentosStore.commit("SET_IS_VALID_TO_NEXT", vl);
    },

    getSearchUser: lodash.debounce(function (search) {
      if (search && search.trim().length >= 2) {
        this.agendamentosStore.dispatch("getUser", {
          search: search,
          situacao_rua: this.situacao_rua ? 1 : 0,
        });
      }
    }, 1000),

    setUser(userId) {
      this.users_selected = {};
      this.selected_users = [];
      if (userId) {
        const user = this.agendamentosStore.state.usuarios.find(
          (e) => e.usuario_id === userId
        );

        this.agendamentosStore.commit("SET_USUARIO", user);
      } else {
        this.agendamentosStore.commit("SET_USUARIO", null);
      }
    },

    setLocal(localId) {
      if (localId) {
        const local_atendimento = this.agendamentosStore.state.locais_atendimento.find(
          (e) => e.id === localId
        );

        this.agendamentosStore.commit("SET_LOCAL_ATENDIMENTO", local_atendimento);
      }
    },

    setTecnico(tecnicoId) {
      if (tecnicoId) {
        const tecnico = this.agendamentosStore.state.tecnicos.find(
          (e) => e.id === tecnicoId
        );

        this.agendamentosStore.commit("SET_TECNICO", tecnico);
      }
    },

    filter(option, searchText) {
      if (!searchText) return true;

      return option;
    },

    async saveUsuario() {
      if (!this.situacao_usuario) {
        if (!this.item.use_nome_social) this.item.nome_social = null;

        if (this.item.situacao_rua) this.limparEstado(this.item.endereco, ["referencia_endereco", "abrigo"]);

        let ladda = Ladda.create(document.querySelector(".btn-submit-stepper"));
        ladda.start();

        await this.agendamentosStore.dispatch("saveUser", {
          item: this.treatObjectUser()
        }).then(response => {
          if (response?.data?.data) {
            this.$snack.success({
              button: false,
              text: "Usuário/Familia cadastrada com sucesso!",
            });

            this.$emit("pessoa-cadastrada", response.data.data);
            this.$emit("membros-familia-atendimento", []);
          }

          ladda.stop();
        })
      } else {
        if (!this.selected_users.length) {
          swal.fire({
            title: "Error",
            html: "Selecione o(s) membro(s) da família para prosseguir com o atendimento",
            icon: "error",
          });
          this.setIsValidToNext(false);
        } else {
          this.$emit("pessoa-cadastrada", null);
          this.$emit("membros-familia-atendimento", this.selected_users);

          this.setIsValidToNext(true);
        }
      }

      this.agendamentosStore.commit("SET_ATENDIMENTO", null);
      this.agendamentosStore?.commit("SET_LOCAL_ATENDIMENTO", null);
      this.limparEstado(this.atendimento, ["data_cadastro"]);
    },

    async saveAtendimento() {
      if (this.selected_users.length) {
        this.atendimento.pessoas = this.selected_users.map(e => e.id).join(", ");

        this.atendimento.familia_id = this.agendamentosStore.state.usuario?.id
      } else {
        this.atendimento.familia_id = this.agendamentosStore.state.pessoa_cadastrada?.id;

        this.atendimento.pessoas = this.agendamentosStore.state.pessoa_cadastrada.responsavel_familiar_id;
      }

      if (!this.agendamentosStore.state?.local_atendimento?.permite_outra_unidade)
        this.atendimento.outra_unidade = null;

      let ladda = Ladda.create(document.querySelector(".btn-submit-stepper"));
      ladda.start();

      if (this.agendamentosStore.state?.atendimento?.id) {
        await this.agendamentosStore.dispatch("putAtendimento", {
          atendimento: this.atendimento,
          atendimento_id: this.agendamentosStore.state?.atendimento?.id
        }).then(r => {
          if (r?.data?.data) {
            this.$snack.success({
              button: false,
              text: "Atendimento atualizado com sucesso!",
            });
          }
        })
      } else {
        await this.agendamentosStore.dispatch("saveAtendimento", {
          item: this.atendimento
        }).then(r => {
          if (r?.data?.data) {
            this.$snack.success({
              button: false,
              text: "Atendimento criado com sucesso!",
            });
          }
        })
      }

      ladda.stop();
      this.getDataAgendamento(this.agenda.data_agendamento);

      // if (this.is_tecnico) this.getAgenda(this.tecnico_logado?.id, this.agenda.data_agendamento);
    },

    treatObjectUser() {
      let contatos = [];

      if (this.email.contato) {
        contatos = [
          ...(this.item.contatos.some(e => e.contato) ? this.item.contatos : []),
          { ...this.email },
        ];
      } else if (this.item.contatos.some(e => e.contato)) {
        contatos = [...this.item.contatos];
      } else {
        contatos = [];
      }

      return {
        ...this.item,
        contatos,
      };
    },

    clearStep1() {
      this.agendamentosStore.commit("SET_USUARIO", null);
      this.agendamentosStore.commit("SET_TECNICOS", []);
      this.limparEstado(this.item);
      this.limparEstado(this.email);
      this.limparEstado(this.agendamento);
      this.limparEstado(this.agendamento_cadastro);
      this.limparEstado(this.agenda, ["data_agendamento"]);
      this.agenda.data_agendamento = moment().format("YYYY-MM-DD");

      this.limparEstado(this.atendimento, ["data_cadastro"]);
      this.atendimento.data_cadastro = moment().format("YYYY-MM-DD");

      if (this.atendimento.hasOwnProperty("tipos")) this.atendimento.tipos = null;

      this.situacao_usuario = true;
      this.selected_users = [];
      this.users_selected = {};
      this.agendamentosStore.commit("SET_PESSOA_CADASTRADA", null);
      this.usuario = null;
      this.setIsValidToNext(true);
    },

    getAgenda(tecnico_id, data_agendamento) {
      this.agendamentosStore.dispatch("getAgenda", {
        tecnico_id: tecnico_id,
        dia: data_agendamento,
        loading_mutations: "SET_LOADING_AGENDA",
        model_mutations: "SET_AGENDA"
      });
    },

    getDataAgendamento(data) {
      // if (this.is_tecnico) this.getExpediente(this.tecnico_logado?.unidade_id, data);

      this.dataFormatadaAgenda = moment(data).format('dddd, D [de] MMMM [de] YYYY');

      this.dataFormatadaAgenda = this.dataFormatadaAgenda.charAt(0).toUpperCase() + this.dataFormatadaAgenda.slice(1);
    },

    async saveAgendamento() {
      this.agendamento_cadastro.dia = this.agenda.data_agendamento;
      this.agendamento_cadastro.descricao = this.atendimento.descricao_sumaria;
      const atendimentoId = this.agendamentosStore.state?.atendimento?.id;

      this.agendamento_cadastro.atendimento.id = atendimentoId;
      this.agendamento_cadastro.atendimento_id = atendimentoId;
      this.agendamento_cadastro.usuarios_ids = this.situacao_usuario
        ? this.selected_users.map(user => user.id)
        : [this.agendamentosStore.state.pessoa_cadastrada?.responsavel_familiar_id]
            .filter(Boolean);
      this.agendamento_cadastro.unidade_id = this.agendamento.unidade_id;
      this.agendamento_cadastro.tecnico_id = this.agenda.tecnico_id;

      let ladda = Ladda.create(document.querySelector(".btn-submit-agendamento-cadastro"));
      ladda.start();

      await this.agendamentosStore.dispatch("saveAgendamento", {
        item: this.agendamento_cadastro
      }).then(r => {
        if (r?.data?.data) {
          this.$snack.success({
            button: false,
            text: "Agendamento realizado com sucesso!",
          });

          this.getAgenda(
            this.agenda.tecnico_id,
            this.agenda.data_agendamento
          );

          this.$bvModal.hide('agendamentos-modal');
        }

        ladda.stop();
      })
    },

    finalizar() {
      this.clearStep1();

      this.agendamentosStore.commit("SET_AGENDA", {});
      this.agendamentosStore.commit("SET_EXPEDIENTE_AGENDA", null);

      this.$snack.success({
        button: false,
        text: "Retornando ao início!",
      });

      this.setIsValidToNext(true);
    },

    impressaoAgendamento(item) {
      this.agendamentosStore.dispatch("getAgendamento", {
        agenda_atendimento_id: item.agenda_atendimento.id,
      }).then(res => {
        if (res?.data?.data) {
          this.$bvModal.show("atendimento-agenda-impressao-modal");
        }
      })
    },

    getAtendimento() {
      if (this.agendamentosStore.state?.atendimento?.id) {
        this.agendamentosStore.dispatch("getAtendimento", {
          atendimento_id: this.agendamentosStore.state?.atendimento?.id,
        }).then(res => {
          if (res?.data?.data) {
            this.atendimento = res.data.data;
          }
        })
      }
    },

    cancelar(item) {
      swal
        .fire({
          title: "Confirmação de cancelamento",
          text: "Caso este seja o único agendamento, o atendimento será finalizado e o horário ficará disponível para novos agendamentos na agenda. Caso contrário, apenas o horário será liberado. Confirma o cancelamento?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.agendamentosStore.dispatch("cancelar", {
              agendamento_id: item.agenda_atendimento.id,
            }).then(res => {
              if (res.status === 204) {
                this.getAgenda(
                  this.agenda.tecnico_id,
                  this.agenda.data_agendamento
                );

                this.$snack.success({
                  button: false,
                  text: "Agendamento cancelado com sucesso!",
                });
              }
            })
          }
        });
    },

    verificarUsuarioLogadoAgenda() {
      return (this.agenda.data_agendamento && this.agenda.tecnico_id);
    },

    getTextStatusStyle(item) {
      return {
        color: (item?.atendimento && item?.status?.value === "REAGENDADO") ? "#0d6efd" : ""
      }
    }
  }
}
</script>
